import { config } from '@/config/config.ts'
import { RouteNames } from '@/routes'

export function buildBeneficiaryAppUrlFromBeneficiaryId({
  beneficiaryId,
}: {
  beneficiaryId: string
}) {
  return `${config.chatUrl}/${RouteNames.Beneficiaries}/${beneficiaryId}${'?source=qr-code'}`
}
